import {
    AminoTypes,
} from '@cosmjs/stargate';
import {Registry} from '@cosmjs/proto-signing';
import {
    cosmosProtoRegistry,
    cosmosAminoConverters,
} from 'cosmos-js-telescope';

const converters = {...cosmosAminoConverters};

const registry = new Registry([
    ...cosmosProtoRegistry,
]);

const aminoTypes = new AminoTypes({
    ...converters,
});

export const getCustomRegistry = () => registry;
export const getCustomAminoTypes = () => aminoTypes;
